import IComponent from "components/commons/IComponent";
import "./LDSPanel.scoped.css";
import SwitchButton from "components/commons/SwitchButton";
import ZoomTo from "components/ZoomTo";
import LayerToggleUtil from "utils/LayerToggleUtil";
import geometryTools from "utils/geometryTools";
import SensorInfo from "./SensorInfo";
import React from "react";
import ReactDOM from "react-dom/client";
import GetArcGISToken from "utils/GetArcGISToken";
let ZoomToInstance = null;

const sensorCount_row1 = ["Camera", "Depth", "Displacement"];
const sensorCount_row2 = ["Impact", "Laser", "Tilt"];

const verticalOffset = {
  screenLength: 40,
  maxWorldLength: 200,
  minWorldLength: 10,
};

const callout = {
  type: "line", // autocasts as new LineCallout3D()
  color: "white",
  size: 2,
  border: {
    color: [50, 50, 50],
  },
};

const ALERT_ICON_BG_COLOR = "#ff8800";

const pointSymbol = {
  type: "point-3d",
  symbolLayers: [
    {
      type: "icon",
      resource: {
        href: "",
      },
      size: 20,
      outline: {
        color: "white",
        size: 2,
      },
    },
  ],

  verticalOffset: verticalOffset,

  callout: callout,
};

let sensorsStatusJSON = null;
class ClassName extends IComponent {
  constructor(props) {
    super(props);
    let component = this.createElement(ZoomTo, props);
    ZoomToInstance = new component.type(props);
    ZoomToInstance.props = props;
    this.state = {
      dashboard: {},
      barrierList: [],
      sensorReading: null,
      // sensorInfo: null,
      activeOnly: true,
    };
    this.checkSensorStatusTimer = null;
  }
  componentDidMount() {
    this.getBarrierInfo();
    this.getBarrierList();

    if (!this.props.mapView.map.findLayerById("LDS-Sensors")) {
      let sensorLayer = this.createSensorLayer();
      this.props.mapView.map.add(sensorLayer);
      this.updateFeatureLayerRenderer(sensorLayer);
      this.bindCheckSensorAlertEvent(sensorLayer);
    }
  }
  createSensorLayer() {
    return new geometryTools.FeatureLayer({
      id: "LDS-Sensors",
      portalItem: { id: this.$config.LDS_SENSORS_ITEM_ID },
      definitionExpression: "1=2",
      outFields: "*",
      returnZ: true,
      elevationInfo: {
        mode: "relative-to-scene",
        offset: 3,
        unit: "meters",
      },
      screenSizePerspectiveEnabled: false,
      popupTemplate: {
        title: "{SLOPE_NO_} / {SITE_ID} / {SENSOR_ID}",
        content: this.getSensorInformation.bind(this),
      },
    });
  }
  updateFeatureLayerRenderer(featureLayer) {
    featureLayer.when(() => {
      // to add callout and verticalOffset, convert picture-marker symbol to point symbol
      let tmpRenderer = featureLayer.renderer.clone();
      featureLayer.elevationInfo = { mode: "relative-to-ground" };
      let alertInfos = [];
      tmpRenderer.uniqueValueInfos.forEach((valueInfo) => {
        let originIconUrl = valueInfo.symbol.url;
        let newPtSymbol = JSON.parse(JSON.stringify(pointSymbol));
        newPtSymbol.symbolLayers[0].resource.href = originIconUrl;
        valueInfo.symbol = newPtSymbol;

        let alertValueInfo = valueInfo.clone();
        alertValueInfo.value += " Alert";
        alertValueInfo.label += " (Alert)";
        alertValueInfo.symbol.symbolLayers.items[0].material = {
          color: ALERT_ICON_BG_COLOR,
        };
        alertInfos.push(alertValueInfo);
      });
      tmpRenderer.uniqueValueInfos.push.apply(
        tmpRenderer.uniqueValueInfos,
        alertInfos
      );
      featureLayer.renderer = tmpRenderer;
    });
  }

  bindCheckSensorAlertEvent(featureLayer) {
    if (this.checkSensorStatusTimer == null) {
      this.checkSensorStatusTimer = window.setInterval(
        function() {
          this.intervalFunctionForChangingSensorColor(featureLayer);
        }.bind(this),
        10 * 1000
      );
    }

    featureLayer.on(
      "layerview-destroy",
      function(view, lryView) {
        console.log("LDS feature layer destroy");
        if (this.checkSensorStatusTimer !== null) {
          window.clearInterval(this.checkSensorStatusTimer);
          this.checkSensorStatusTimer = null;
        }
      }.bind(this)
    );
  }

  async intervalFunctionForChangingSensorColor(featureLayer) {
    // fetch sensor status url and change color
    if (featureLayer.definitionExpression == "1=2") return;
    let currentSlopeSensorFeatures = await featureLayer.queryFeatures();
    if (
      currentSlopeSensorFeatures.features &&
      currentSlopeSensorFeatures.features.length === 0
    )
      return; //if no sensor in screen, return

    try {
      let {
        PORJECT_ID,
        BARRIER_ID,
        SITE_ID,
      } = currentSlopeSensorFeatures.toJSON().features[0].attributes;
      this.makeHttpQuery(
        this.$config.LDS_WEB_SERVICE_URL + "ListSensor",
        "POST",
        {
          ProjectID: PORJECT_ID,
          SiteID: SITE_ID,
          BarrierID: BARRIER_ID,
        },
        true
      ).then(function(result) {
        sensorsStatusJSON = JSON.parse(result);
        let tmpRenderer = featureLayer.renderer.clone();
        let alertSensorIDs = sensorsStatusJSON.reduce((p, c, i) => {
          if (c.SENSORALERT) p.push(c.SENSORID);
          return p;
        }, []);

        let alertIdList = alertSensorIDs.reduce(
          (p, c, i) => ((p[c] = 1), p),
          {}
        );
        let valExprs = [];
        valExprs.push("var list = " + JSON.stringify(alertIdList));

        valExprs.push(
          'if(HasKey(list,$feature.SENSOR_ID)){return $feature.SENSOR_TYP+" Alert"}else{return $feature.SENSOR_TYP}'
        );
        console.log((tmpRenderer.valueExpression = valExprs.join(";")));
        featureLayer.renderer = tmpRenderer;
      });
    } catch (error) {
      console.error(error);
    }
  }
  getBarrierInfo() {
    this.makeHttpQuery(
      this.$config.LDS_WEB_SERVICE_URL + "DashboardDetail",
      "POST",
      { Enable: this.state.activeOnly ? 1 : 0 },
      true
    )
      .then((result) => {
        let dashboard = JSON.parse(result);
        Object.keys(dashboard).forEach(
          (i) => (dashboard[i] = dashboard[i].toString())
        );
        this.setState({ dashboard });
      })
      .catch((err) => {
        console.debug(err);
        this.setState({
          dashboard: {
            cnt_BarrierAlert: "!",
            cnt_Barrier: "!",
            cnt_Sensor: "!",
            cnt_Camera: "!",
            cnt_Depth: "!",
            cnt_Displacement: "!",
            cnt_Impact: "!",
            cnt_Laser: "!",
            cnt_Pull: "!",
            cnt_Tilt: "!",
          },
        });
      });
  }
  getBarrierList() {
    this.makeHttpQuery(
      this.$config.LDS_WEB_SERVICE_URL + "ListBarrier",
      "POST",
      { Enable: this.state.activeOnly ? 1 : 0 },
      true
    )
      .then((result) => {
        let barrierList = JSON.parse(result);
        this.setState({ barrierList });
      })
      .catch((ex) => {
        this.setState({
          barrierList: [
            {
              LOCATION: "Error",
              FEATURENO:
                "Error occurred when trying to get the barrier and sensor information",
            },
          ],
        });
      });
  }
  getSensorInformation(item) {
    var attr = item.graphic.attributes;
    let sensorStatus = sensorsStatusJSON.find(
      (i) => i.SENSORID === attr.SENSOR_ID
    );
    let lastReadingDate = sensorStatus?.SENSORDATETIME;
    let popupContainer = document.createElement("DIV");
    let infoRoot = ReactDOM.createRoot(document.createElement("DIV"));
    infoRoot.render(
      <SensorInfo
        showDialog={this.props.showDialog}
        sensorInfo={attr}
        popupContainer={popupContainer}
        lastReadingDate={lastReadingDate}
      />
    );
    // SensorInfo.componentDidMount();
    return popupContainer;
  }
  async performBarrerInfoSearch(slopeNo) {
    let vm = this;
    ZoomToInstance.props = this.props;
    ZoomToInstance.queryForMMS.apply(ZoomToInstance, [slopeNo]);

    if (this.props.mapType === 2) return;

    var bimIndex = this.$config.mapList.layer3D["BIM Model"].find(
      (c) => c.title == slopeNo.replaceAll(" ", "").replaceAll("/", "")
    );
    if (typeof bimIndex !== "undefined") {
      LayerToggleUtil.toggle3DLayer(
        "BIM Model",
        bimIndex,
        true,
        this.props.mapView,
        false,
        true
      );
      bimIndex.layer.when(async () => {
        let newCam = vm.props.mapView.camera.clone();
        newCam.tilt = 45;
        await this.props.mapView.goTo(newCam, {
          animate: false,
        });
        await this.props.mapView.goTo(bimIndex.layer.fullExtent, {
          animate: false,
        });
      });
    }
  }
  handleBarrierClick(item) {
    var slopeName = item.FEATURENO.trim().replace("  ", " ");
    if (item.LOCATION === "Error") return;
    let tmpLayer = this.props.mapView.map.findLayerById("LDS-Sensors");
    tmpLayer.definitionExpression = `SLOPE_NO_ = '${slopeName}'`;
    this.performBarrerInfoSearch(slopeName);
    this.intervalFunctionForChangingSensorColor(tmpLayer);
  }
  render() {
    let { dashboard, barrierList, sensorInfo, activeOnly } = this.state;
    return (
      <div className="LDSPanelContainer">
        <div className="PanelTitle">
          <span>LDS Summary</span>
        </div>
        {GetArcGISToken.user.isAdmin && (
          <div
            className="SubPanelContent BottomLine"
            style={{ padding: "5px 20px" }}
          >
            <SwitchButton
              checked={activeOnly}
              label="Show Active Only"
              placeAtRight={true}
              onClick={() => {
                this.setState({ activeOnly: !activeOnly }, () => {
                  this.getBarrierInfo();
                  this.getBarrierList();
                });
              }}
            />
          </div>
        )}
        <div className="SubPanelContent">
          <div className="EqualWidthChildren">
            <div className="NumberBlock Big Alert">
              <div>
                {dashboard.cnt_BarrierAlert || <span className="icn_loading" />}
              </div>
              <div>Barrier Alert</div>
            </div>
            <div className="NumberBlock Big">
              <div>
                {dashboard.cnt_Barrier || <span className="icn_loading" />}
              </div>
              <div>Barrier</div>
            </div>
          </div>
        </div>
        <div className="SubPanelContent SecondSensorPanel">
          <div className="EqualWidthChildren">
            <div className="NumberBlock Big">
              <div>
                {dashboard.cnt_Sensor || <span className="icn_loading" />}
              </div>
              <div>Sensor</div>
            </div>
          </div>
          <div className="EqualWidthChildren">
            {sensorCount_row1.map((i, j) => (
              <div className="NumberBlock Small" key={j}>
                <div>
                  {dashboard["cnt_" + i] || <span className="icn_loading" />}
                </div>
                <div>{i}</div>
              </div>
            ))}
          </div>
          <div className="EqualWidthChildren">
            {sensorCount_row2.map((i, j) => (
              <div className="NumberBlock Small" key={j}>
                <div>
                  {dashboard["cnt_" + i] || <span className="icn_loading" />}
                </div>
                <div>{i}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="LDSSeparator" />
        <div className="SubPanelTitle">Barrier</div>
        <div className="ListItems">
          {barrierList.length > 0 ? (
            barrierList.map((i, j) => (
              <div
                key={`${i.FEATURENO}-${j}`}
                className="ListItemBottomLine"
                onClick={() => this.handleBarrierClick(i)}
              >
                <b>{i.LOCATION}</b>
                <br />
                {i.FEATURENO}
              </div>
            ))
          ) : (
            <div className="ListItemBottomLine EqualWidthChildren">
              <span className="icn_loading" />
            </div>
          )}
        </div>
        {/* <SensorInfo sensorInfo={sensorInfo} popupContainer={popupContainer} /> */}
      </div>
    );
  }
}

export default ClassName;
